import PropTypes from 'prop-types'

import React, { Component } from 'react'
import { isEqual } from 'lodash'

import { getTrimmedLink } from 'shared/helpers/linkUtils'

import Navigation from 'Navigation/Navigation'
import Filters from 'Counterparties/Customers/components/Filters/Filters'
import ListView from 'shared/components/ListView/ListView'
import SelectableCounterpartyItem from 'Counterparties/shared/components/SelectableCounterparty/SelectableCounterparty'

export class Customers extends Component {
  static propTypes = {
    loadList: PropTypes.func,
    cleanList: PropTypes.func,
    hasNextPage: PropTypes.bool,
    lastPageLoaded: PropTypes.number,
    customers: PropTypes.arrayOf(PropTypes.object),
    filters: PropTypes.object,
    updateCustomer: PropTypes.func,
    customerId: PropTypes.number,
    location: PropTypes.object
  }

  constructor (props) {
    super(props)
    this.selectCustomer = this.selectCustomer.bind(this)
    this.extendList = this.extendList.bind(this)
  }

  extendList () {
    const {hasNextPage, lastPageLoaded, customers, filters} = this.props
    if (hasNextPage) {
      this.props.loadList(customers, filters, lastPageLoaded + 1)
    }
  }

  componentDidMount () {
    this.extendList()
  }

  componentDidUpdate (prevProps) {
    const { filters } = this.props
    if (prevProps.filters && !isEqual(prevProps.filters, filters)) {
      this.props.loadList([], filters, 1)
    }
  }

  componentWillUnmount () {
    this.props.cleanList()
  }

  selectCustomer (data) {
    const {updateCustomer, location: {pathname}} = this.props
    updateCustomer('customer', data, getTrimmedLink(pathname, 1))
  }

  render () {
    const {customers, customerId} = this.props

    return (
      <div className='selectable-customers-list'>
        <ListView data={customers} template={SelectableCounterpartyItem(customerId, this.selectCustomer)} />
      </div>
    )
  }
}

export default class CustomersWithNavigation extends Component {
  static propTypes = {
    location: PropTypes.object,
    t: PropTypes.func,
    cameFrom: PropTypes.string
  }
  constructor (props) {
    super(props)
    this.extendList = this.extendList.bind(this)
  }

  extendList () {
    this.refs.customers.extendList()
  }

  render () {
    const {t, location: {pathname}, cameFrom} = this.props
    const actions = [
      {icon: 'icon-add', path: `/customers/new`, state: cameFrom}
    ]
    return (
      <Navigation title={t('navbar', 'title').s} actions={cameFrom && actions} hideFooter backLink={getTrimmedLink(pathname, 1)} filterBlock infinityScrollHandler={this.extendList}>
        <Filters />
        <Customers {...this.props} ref='customers' />
      </Navigation>
    )
  }
}
